import { filterResults, unFlattenResults } from '@tracsis/library/lib/helpers';
import Pagination from '@tracsis/library/src/components/Pagination/Pagination';
import ResourceList from '@tracsis/library/src/components/ResourceList/ResourceList';
import React from 'react';
import { useFlexSearch } from 'react-use-flexsearch';

const ResourceTemplate = ({
	siteName,
	posts,
	searchIndex,
	pageContext,
	filter = true,
	allResources,
	hasSearch = true,
	slug = 'resources',
	breaker,
	title,
	location
}: {
	siteName: string;
	posts: any;
	pageContext: any;
	searchIndex?: any;
	filter?: boolean;
	allResources: string;
	hasSearch?: boolean;
	slug?: string;
	breaker?: React.ReactNode;
	title?: string;
	location: any;
}) => {
	let results;
	let querySearch = undefined;
	let queryFilter = undefined;

	if (searchIndex) {
		const { index, store } = searchIndex;

		const { search } = location;
		const querySearch = new URLSearchParams(search).get('s');
		const queryFilter = new URLSearchParams(search).get('service');
		const queriedResults = useFlexSearch(querySearch, index, store);

		const filteredQueriedResults = filterResults(
			queriedResults,
			queryFilter,
			'resource'
		);
		const filteredPosts = filterResults(posts.edges, queryFilter, 'resource');

		results = querySearch
			? unFlattenResults(filteredQueriedResults)
			: filteredPosts;
	}

	return (
		<>
			<ResourceList
				siteName={siteName}
				posts={searchIndex ? results : posts.edges}
				pageContext={pageContext}
				hasSearch={hasSearch}
				hasFilters={filter}
				showDates
				querySearch={querySearch}
				filterQuery={queryFilter}
				pages={pageContext.numberOfPages}
				currentPage={pageContext.currentPage}
				allResources={allResources}
				breaker={breaker}
			/>

			{((pageContext && !querySearch && !queryFilter) ||
				(pageContext && !querySearch && queryFilter === 'all')) && (
					<Pagination pageContext={pageContext} slug={slug} />
				)}
		</>
	);
};

export default ResourceTemplate;
